export const getScriptSrcWithPrefix = (relativeSrc: string) =>
  `${
    process.env.ASSET_PREFIX ? `${process.env.ASSET_PREFIX}/_next/static/scripts` : '/next-assets'
  }${relativeSrc}`

export const getMediaSrcWithPrefix = (relativeSrc: string) =>
  `${
    process.env.ASSET_PREFIX ? `${process.env.ASSET_PREFIX}/_next/static/media` : '/next-assets'
  }${relativeSrc}`
